import React from 'react';
import { connect } from 'react-redux';
import Auth from 'j-toker';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import BannerMessage from './BannerMessage';

import { getTranslatedString, getLandlordVerbiageOrTranslatedString } from 'helpers/i18n';

const StyledContainer = styled.div`
  background-color: '#fdfdfd';
  margin-top: '65px';
`;
const StyledHeader = styled.div`
  margin: '0 0 7px 0';
`;

const StyledWelcomeMessage = styled.p`
  font-size: '16px';
  margin: '20px 0 10px';
  text-align: 'justify';
`;

const StyledBoldMessage = styled.b`
  font-family: 'Circular-Bold';
`;

const NonActivePortal = ({ greetingNameType, showWelcomeMessage, activeLease }) => {
  return (
    <StyledContainer className="body" role="main">
      <BannerMessage />
      {/* TODO */}
      {this.renderPaymentOptions()}
      <div className="centers" style={{ maxWidth: '1000px', margin: 'auto' }}>
        <div style={{ padding: '20px 0px' }}>
          <StyledHeader>
            {getLandlordVerbiageOrTranslatedString('nameGreeting', {
              name: Auth.user[greetingNameType] || Auth.user.first_name,
            })}
          </StyledHeader>
          {!showWelcomeMessage && activeLease && (
            <StyledWelcomeMessage>
              <i className="em em-wave" />
              {'  '}
              <StyledBoldMessage>
                {' '}
                {getTranslatedString('portal.leaseSubmitted')}{' '}
              </StyledBoldMessage>
              <i className="em em-wave" />
              {'  '}
              {getTranslatedString('portal.portalInactive')}
            </StyledWelcomeMessage>
          )}
          {/* TODO */}
          {this.renderToDoComponent()}
        </div>
      </div>
    </StyledContainer>
  );
};

const mapStoreToProps = (store) => ({
  greetingNameType: store.userTypes.greetingNameType,
  showWelcomeMessage: store.tenantOverview.show_welcome_message,
  activeLease: store.tenantOverview.active_lease,
});

const mapDispatchToProps = {};

NonActivePortal.propTypes = {
  greetingNameType: PropTypes.string,
  showWelcomeMessage: PropTypes.bool,
  activeLease: PropTypes.bool,
};

export default connect(mapStoreToProps, mapDispatchToProps)(NonActivePortal);
